import React from "react";
// import { useNavigate } from "react-router-dom";
// import moment from 'moment'
import moment from 'moment-timezone';
// import { ReactComponent as UserIcon } from "../icons/UserIcon.svg";

// import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
// import CheckBoxIcon from "@mui/icons-material/CheckBox";
// import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
// import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
// import DeleteIcon from "@mui/icons-material/Delete";
// import EditIcon from "@mui/icons-material/Edit";
// import InfoIcon from "@mui/icons-material/Info";
// import VisibilityIcon from '@mui/icons-material/Visibility';

// import CheckIcon from '@mui/icons-material/Check';
// import EditIcon from '@mui/icons-material/Edit';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
// import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { ReactComponent as ActionIcon } from '../icons/ActionIcon.svg'
import UserAvatar from "../components/UserAvatar";


// import { DeleteConfirmationModal } from "../components/AppModal";
// import { useUpdateMembership } from '../hooks/memberhooks'
// import { statusColors } from "../utils/enums";
import { capitalizeWords, getBookingStatusColor, planRecurrenceMap, styleThousandCommas } from "../utils/helpers";
import { ResourceBookingSchema, PlanRecurrenceOptions, ResourceType } from "../data/types";


// const colors: {[key: string]: string} = statusColors();

type TransactionRecordProps = {
  request: ResourceBookingSchema
  isRequests?: boolean
  resourceType: ResourceType
}

const TransactionRecord: React.FC<TransactionRecordProps> = (props) => {

  var { request, resourceType } = props

  var dateFieldValue = ""
  switch(request.resource_type){
    case 'training':
      dateFieldValue =  moment(request.start_time).tz('America/New_York').format('ddd MMM DD, YYYY @ hh:mm a')
      break
    case 'expert':
      dateFieldValue =  moment(request.start_time).tz('America/New_York').format('ddd MMM DD, YYYY @ hh:mm a')
      break
  }

  // const circle = (status: string) => {
  //   return (
  //     <div
  //       className={`z-0 w-2 h-2 animate-pulse ${colors[status]} rounded-full`}
  //     ></div>
  //   );
  // };
  

  // const declineRequest = () => {
  //   if (updateMembership !== undefined) {
  //     updateMembership({username: request.username, status: request.status === 'declined' ? 'removed' : 'declined'})
  //  } 
  // }



  return request ? (
    <tr className="hover:bg-gray-50">

      <td className="flex flex-row items-center px-6 py-4 whitespace-nowrap text-sm text-gray-800">
        {/* <UserIcon className='text-[#E6E6E6] h-8 ' /> */}
        {request.user_avatar ? (
          <img src={request.user_avatar} alt="User Avatar" className="h-8 w-8 rounded-full mr-2" />
        ) : (
          <UserAvatar 
            firstName={request?.user_full_name?.split(' ')[0]} 
            lastName={request?.user_full_name?.split(' ')[1]} 
            username={request.username} 
            email={request?.username}
            className='h-8 mr-3' 
            size="sm"
          />
        )}
        {
          request.user_full_name ? request.user_full_name : request.username
        }
      </td>

      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800"> {request?.resource_name ? request?.resource_name : "-"} </td>

      {
        (dateFieldValue) && (
          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{dateFieldValue}</td>
        )
      }

    {
        (resourceType && ["kitchen", "training", "expert"].includes(resourceType)) ? (
          <>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
              {request?.total_hours ? request?.total_hours.toFixed(1) : 0} hours
            </td>
          </>
        ) : (
          <></>
        )
      }

      {
        resourceType === "kitchen" ? (
          <>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
              ${request?.plan_rate ? styleThousandCommas(request?.plan_rate.toFixed(2)) : 0} / {planRecurrenceMap[request?.plan_recurrence as PlanRecurrenceOptions]}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
              ${request?.subtotal_cost ? styleThousandCommas(request?.subtotal_cost.toFixed(2)) : 0}
            </td>
          </>
        ) : (
          <></>
        )
      }

      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
        ${request?.total_cost ? styleThousandCommas(request?.total_cost.toFixed(2)) : 0}
      </td>

      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
        {moment.utc(request?.created).fromNow()}
      </td>

      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
        
          {/* <div className="flex justify-center items-center"> */}
            <span className="flex items-center text-sm" style={{color: getBookingStatusColor(request.status || '').primaryTextColor}}>
              <FiberManualRecordIcon style={{fontSize: 15}} />
              <span className="ml-1">
                {(request.status) ? capitalizeWords(request.status.replace(/_/g, ' ')) : 'Pending'}
              </span>
            </span>
          {/* </div> */}
        
      </td>

      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">

        <div className="flex flex-row">
          <ActionIcon className="text-[#4D4D4D] hover:text-primary-300 mx-auto cursor-pointer"/>
        </div>
      </td>

    </tr>
  ) : (<></>);
};

export default TransactionRecord;
